export default "__VITE_ASSET__CfU_Ptuw__"